function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M599.43,30.74C521.55,20.6,477.29,63.8,372.62,68.5,268.62,60.35,229,15.76,150.16,23.31,65.36,31.44-.32,141.94,18.37,252.47s134.52,172.33,193.73,172c47.33-.3,89.13-19.57,143.09-24.17,53.39,6.38,93.1,27,140.31,28.86,59.07,2.33,181.19-55.52,211.44-165.25S683.23,41.65,599.43,30.74Z",
    style: {
      fill: "#1D50FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.43,30.74C521.55,20.6,477.29,63.8,372.62,68.5,268.62,60.35,229,15.76,150.16,23.31,65.36,31.44-.32,141.94,18.37,252.47s134.52,172.33,193.73,172c47.33-.3,89.13-19.57,143.09-24.17,53.39,6.38,93.1,27,140.31,28.86,59.07,2.33,181.19-55.52,211.44-165.25S683.23,41.65,599.43,30.74Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Wall--inject-8"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47.79,
    y: 60.82,
    width: 130.3,
    height: 140.49,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50.94,
    y: 64.21,
    width: 124,
    height: 133.7,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.15,94.88v69.48a18.9,18.9,0,0,1,18.9,18.9v.06H146.3v-.06a18.88,18.88,0,0,1,17.86-18.84V94.83A18.88,18.88,0,0,1,146.3,76H80.05A18.9,18.9,0,0,1,61.15,94.88Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.86,97.38v64.48A17.54,17.54,0,0,1,82.4,179.4v0h61.48v0a17.52,17.52,0,0,1,16.57-17.49V97.34a17.53,17.53,0,0,1-16.57-17.49H82.4A17.53,17.53,0,0,1,64.86,97.38Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221.9,
    y: 60.82,
    width: 130.3,
    height: 140.49,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225.05,
    y: 64.21,
    width: 124,
    height: 133.7,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.26,94.88v69.48a18.9,18.9,0,0,1,18.9,18.9v.06h66.25v-.06a18.88,18.88,0,0,1,17.86-18.84V94.83A18.88,18.88,0,0,1,320.41,76H254.16A18.9,18.9,0,0,1,235.26,94.88Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239,97.38v64.48a17.54,17.54,0,0,1,17.54,17.54.43.43,0,0,1,0,0H318a.43.43,0,0,1,0,0,17.52,17.52,0,0,1,16.58-17.49V97.34A17.53,17.53,0,0,1,318,79.85H256.51A17.53,17.53,0,0,1,239,97.38Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396,
    y: 60.82,
    width: 130.3,
    height: 140.49,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 399.15,
    y: 64.21,
    width: 124,
    height: 133.7,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.37,94.88v69.48a18.91,18.91,0,0,1,18.9,18.9s0,0,0,.06h66.26v-.06a18.87,18.87,0,0,1,17.86-18.84V94.83A18.88,18.88,0,0,1,494.52,76H428.27A18.9,18.9,0,0,1,409.37,94.88Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.08,97.38v64.48a17.54,17.54,0,0,1,17.53,17.54v0h61.48v0a17.52,17.52,0,0,1,16.58-17.49V97.34a17.53,17.53,0,0,1-16.58-17.49H430.61A17.53,17.53,0,0,1,413.08,97.38Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 47.79,
    y: 222.94,
    width: 130.3,
    height: 140.49,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50.94,
    y: 226.34,
    width: 124,
    height: 133.7,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.15,257v69.49a18.9,18.9,0,0,1,18.9,18.9v.05H146.3v-.05a18.88,18.88,0,0,1,17.86-18.85V257A18.88,18.88,0,0,1,146.3,238.1H80.05A18.9,18.9,0,0,1,61.15,257Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.86,259.51V324A17.54,17.54,0,0,1,82.4,341.53v.05h61.48v-.05A17.52,17.52,0,0,1,160.45,324V259.46A17.52,17.52,0,0,1,143.88,242H82.4A17.54,17.54,0,0,1,64.86,259.51Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221.9,
    y: 222.94,
    width: 130.3,
    height: 140.49,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225.05,
    y: 226.34,
    width: 124,
    height: 133.7,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.26,257v69.49a18.9,18.9,0,0,1,18.9,18.9v.05h66.25v-.05a18.88,18.88,0,0,1,17.86-18.85V257a18.88,18.88,0,0,1-17.86-18.85H254.16A18.9,18.9,0,0,1,235.26,257Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239,259.51V324a17.54,17.54,0,0,1,17.54,17.54.43.43,0,0,0,0,.05H318a.43.43,0,0,0,0-.05A17.52,17.52,0,0,1,334.56,324V259.46A17.52,17.52,0,0,1,318,242H256.51A17.54,17.54,0,0,1,239,259.51Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396,
    y: 222.94,
    width: 130.3,
    height: 140.49,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 399.15,
    y: 226.34,
    width: 124,
    height: 133.7,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.37,257v69.49a18.9,18.9,0,0,1,18.9,18.9s0,0,0,.05h66.26v-.05a18.88,18.88,0,0,1,17.86-18.85V257a18.88,18.88,0,0,1-17.86-18.85H428.27A18.9,18.9,0,0,1,409.37,257Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.08,259.51V324a17.53,17.53,0,0,1,17.53,17.54v.05h61.48v-.05A17.52,17.52,0,0,1,508.67,324V259.46A17.52,17.52,0,0,1,492.09,242H430.61A17.53,17.53,0,0,1,413.08,259.51Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 568,
    y: 60.82,
    width: 130.3,
    height: 140.49,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 571.15,
    y: 64.21,
    width: 124,
    height: 133.7,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M581.36,94.88v69.48a18.9,18.9,0,0,1,18.9,18.9v.06h66.25v-.06a18.88,18.88,0,0,1,17.86-18.84V94.83A18.88,18.88,0,0,1,666.51,76H600.26A18.9,18.9,0,0,1,581.36,94.88Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.07,97.38v64.48a17.55,17.55,0,0,1,17.54,17.54.43.43,0,0,1,0,0h61.49a.43.43,0,0,1,0,0,17.52,17.52,0,0,1,16.58-17.49V97.34a17.53,17.53,0,0,1-16.58-17.49H602.61A17.54,17.54,0,0,1,585.07,97.38Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 568,
    y: 222.94,
    width: 130.3,
    height: 140.49,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 571.15,
    y: 226.34,
    width: 124,
    height: 133.7,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M581.36,257v69.49a18.9,18.9,0,0,1,18.9,18.9v.05h66.25v-.05a18.88,18.88,0,0,1,17.86-18.85V257a18.88,18.88,0,0,1-17.86-18.85H600.26A18.9,18.9,0,0,1,581.36,257Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.07,259.51V324a17.54,17.54,0,0,1,17.54,17.54.43.43,0,0,0,0,.05h61.49a.43.43,0,0,0,0-.05A17.52,17.52,0,0,1,680.66,324V259.46A17.52,17.52,0,0,1,664.08,242H602.61A17.54,17.54,0,0,1,585.07,259.51Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M621.59,340.66s11.68,18.65,16.56,36.7c3.47,12.82,3.63,38.28,3.63,38.28s.23-75.53,17.61-104.78",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M668.78,245.47s-16.84,27-21.53,55.18-5.79,98-5.79,98c-.28-14.62-2.48-68.15-7.17-91.33a173.17,173.17,0,0,0-13.25-40",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624.69,275.48s14.09.65,20.67-9.92,2.25-20.69-3.93-21.43-8.87,6.91-11.16,3.24,6.57-10.57-3.36-16.92-14.57,2.76-17.72-.5-.88-11.76-7.44-15.5-9.63.92-13.26,1.07-15.07-6-19.64-1.16,6.36,16.54,1.23,16.89-7.21,10.35-3,16.82,17.58,9,15,12.42-15.43,3.17-10.21,10.73,22.94,8,25.49,8.95-8.16,2.86-6.35,9.93,16.53,8,26,3.41S624.69,275.48,624.69,275.48Z",
    style: {
      fill: "#b0b0b0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584.05,227.79s29.92,19.55,40.64,47.69",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "582.58 241.48 602.64 243.44 597.75 226.81",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "598.73 264.48 618.78 264.48 620.25 246.38",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M666,251.52s-11.43.52-16.77-8.06-1.83-16.79,3.19-17.39,7.2,5.61,9.06,2.63-5.34-8.58,2.73-13.74,11.82,2.24,14.38-.4.71-9.55,6-12.58,7.81.74,10.76.87,12.24-4.88,15.94-.95-5.16,13.43-1,13.71,5.86,8.4,2.48,13.66-14.28,7.34-12.15,10.08,12.52,2.57,8.28,8.71-18.62,6.54-20.68,7.26,6.62,2.32,5.15,8.07-13.42,6.45-21.11,2.76S666,251.52,666,251.52Z",
    style: {
      fill: "#b0b0b0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M698.94,212.8s-24.28,15.88-33,38.72",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "700.14 223.92 683.85 225.51 687.83 212.01",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "687.03 242.59 670.75 242.59 669.56 227.89",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628.55,353.91s9.27.43,13.6-6.54,1.49-13.62-2.58-14.1-5.84,4.55-7.35,2.13,4.33-7-2.22-11.15-9.59,1.82-11.67-.32-.58-7.75-4.9-10.21-6.34.6-8.73.71-9.92-4-12.93-.77,4.19,10.89.81,11.12-4.75,6.82-2,11.08,11.57,5.95,9.85,8.18-10.16,2.08-6.72,7.06,15.1,5.31,16.78,5.9-5.37,1.88-4.18,6.54,10.89,5.24,17.12,2.24S628.55,353.91,628.55,353.91Z",
    style: {
      fill: "#b0b0b0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.78,322.5s19.7,12.88,26.77,31.41",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "600.81 331.52 614.02 332.81 610.8 321.86",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "611.45 346.66 624.65 346.66 625.62 334.74",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M656.05,317.58s-14-1.88-18.55-13.46,1.49-20.75,7.7-20.37,7.49,8.38,10.4,5.18-4.58-11.58,6.33-16.05,13.84,5.32,17.53,2.68,3-11.41,10.09-13.91,9.31,2.62,12.85,3.42,15.9-3.21,19.53,2.37-9.22,15.14-4.23,16.4,5.24,11.47,0,17.09-18.91,5.75-16.94,9.54,14.61,5.88,8.12,12.38-24,3.82-26.67,4.25,7.52,4.27,4.47,10.91-17.69,4.87-26.19-1.3S656.05,317.58,656.05,317.58Z",
    style: {
      fill: "#b0b0b0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M704.57,277.93s-32.93,13.89-48.52,39.65",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "703.57 291.67 683.48 290.01 691.27 274.52",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "683.57 311.4 663.84 307.81 665.63 289.74",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618.89,380.2c-1,2.69-1.58,25.57-1.58,28.61,0,20.13,11.1,24.8,24.8,24.8s24.8-3.6,24.8-24.8c0-3-.58-25.92-1.58-28.61Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M103.44,165.3l-3.3-28.86a24.49,24.49,0,0,1,18.21-6.06c11.5.74,14.05,5.32,14.05,5.32l-.09,25.78S117.49,160.4,103.44,165.3Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.91,171.15l.53,16.93s-1.49,2.45,3.94,6.29,8.2,4.15,11,3.83,6.28-6.18,6.28-6.18l.75-10.86s-6.71,2.45-12.14,1.6S107.91,171.15,107.91,171.15Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.24,182.76c-3.54-.56-6.85-5.32-8.73-8.57L108,173l.47,15.06a.28.28,0,0,1,0,.06l16.65-2.08-4.1-3.13A16.43,16.43,0,0,1,118.24,182.76Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.32,166s6.28-5.46,18.08-5.31c0,0,6.8-.37,10.91.75,0,0,.6,11.43,0,15.09s-.08,8.59-7.25,9.49-12.25-2.39-13.82-4.49-3.14-7.24-3.14-7.24a21.88,21.88,0,0,1-3.51-3.89A17.36,17.36,0,0,1,103.32,166Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.74,166.86s3.51-.23,4.78-1.5a2.92,2.92,0,0,0,.83-2.76s-5.16,1.57-7,3.44Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.06,168s-2.47-3-4.78-2.47-2.1,6.35-.15,7.77a3.86,3.86,0,0,0,5.3-.52",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "126.03 164.39 126.18 172.98 122.9 172.61",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.79,174.78a9.94,9.94,0,0,0,5.53,1.71,5.5,5.5,0,0,0,4.1-1.71",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 118.04,
    cy: 166.3,
    rx: 0.9,
    ry: 1.23,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 129.4,
    cy: 166.3,
    rx: 0.9,
    ry: 1.23,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.9,164a12.07,12.07,0,0,1,5.53-1.12",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.15,162.67s2.47-.52,3.89.75",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.68,164.39s.68-.3.9,2.24a10.08,10.08,0,0,1-1,4.86Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.15,415.44l-3.5,8.48s-3.87,5-4.42,7S86,433.5,86,433.5h20.65s1.29-.55,1.29-2.76a42,42,0,0,0-.56-5.53l.74-6.82S98.9,407.7,91.15,415.44Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.1,319.6s.74,30.78.74,36.49S85.07,369.55,85.26,374s5,38.33,5,38.33-1.47,2.95-1.29,3.69.56,1.84.74,2.58,6.08-4.42,10.51-3.32a22.94,22.94,0,0,1,8.1,4.24,54.32,54.32,0,0,0,.74-8.84c-.18-3.14-.74-4.43-1.29-5.35s3.5-48.66,3.69-49.21.92-33.17.92-33.17Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.18,416l11,10.32s6.82,2.95,7,4.61a6.32,6.32,0,0,1-.55,3.13H113.82a14.69,14.69,0,0,1-.55-8.11c.92-4.79,1.66-7.55,1.66-7.55S128.38,416,133.18,416Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.59,323.65s-.19,17.33-.37,23-3.5,18.25-2.76,26.73,1.29,36.49,1.29,36.49-.19,3.87-.37,5a25.45,25.45,0,0,0,.18,5.35c.19.92,9.22-1.47,12.72-2.21a31,31,0,0,1,7.74-.37s0-2.58.18-5.16-.55-4.61-.92-7.74,1.66-34.65,3.14-40S141.29,336,141.29,336l.73-14Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.36,261.39,81.22,322s5.71,2.85,28.4,5.42a91.94,91.94,0,0,0,40.52-4.56l-3.56-61.36s-19,1.28-34.39,1S87.36,261.39,87.36,261.39Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.62,184.48a26.88,26.88,0,0,0,6.28,3.85c3.85,1.71,5.85,2.71,5.85,2.71l-.43,4.14s-.28.71,2.57.71a14.43,14.43,0,0,0,3.71-.28l.29-4.43,7-4.56-.29,6.13s18.84,5,19,7.71,10,40.9,10,40.9L163.51,256l-7.68,7.68-7.68,8.05L147.58,261a11.08,11.08,0,0,1-.43,2.42c-.29.57-1.71,1-1.71,1s-36.25,1.86-45.24.72-12.41-2-13-2.43-9,3.6-9,3.6-8.84-8.42-8.84-10.85,7.55-37.84,8-39.27,2.28-14.55,4.14-15.69,24.54-9.71,24.54-9.71Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.64,252.64s1.69-1.51,7.24-1.18",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.68,249.44s2.36-1.51,6.23,0",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "119.61 199.46 112.05 200.6 111.47 261.39",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.84,221.05c.14-2.41.23-3.9.23-3.9",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.22,262.67s-2.14-2.57-1.29-4.85c.61-1.62,1.94-21.41,2.66-32.77",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 146.78,
    y1: 248.36,
    x2: 147.58,
    y2: 260.96,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 144.86,
    y1: 217.87,
    x2: 146.55,
    y2: 244.71,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.46,205.66a1.35,1.35,0,1,1-1.35-1.35A1.35,1.35,0,0,1,118.46,205.66Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.17,205.66a1.36,1.36,0,1,1-1.36-1.35A1.36,1.36,0,0,1,130.17,205.66Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.46,220.15a1.35,1.35,0,1,1-1.35-1.36A1.34,1.34,0,0,1,118.46,220.15Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.17,220.15a1.36,1.36,0,1,1-1.36-1.36A1.35,1.35,0,0,1,130.17,220.15Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.46,234.63a1.35,1.35,0,1,1-1.35-1.35A1.35,1.35,0,0,1,118.46,234.63Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.17,234.63a1.36,1.36,0,1,1-2.71,0,1.36,1.36,0,0,1,2.71,0Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.46,249.12a1.35,1.35,0,1,1-1.35-1.36A1.35,1.35,0,0,1,118.46,249.12Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.17,249.12a1.36,1.36,0,1,1-1.36-1.36A1.36,1.36,0,0,1,130.17,249.12Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "146.11 255.53 151.52 271.83 158.08 266.11 147.64 252.64 146.11 255.53",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.27,243.17,81.84,241s-10.44,2.61-11.45,3.41-3.61,9-3,11.85,8.24,10.84,9,11,7-1.2,8.63-2,4.22-5.83,4.22-5.83Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.19,243.55s3.38-4.79,4.39-5.8,6.62-1.81,8-3,3-.8,2.41.8-.6,3.22-2,3.62A15,15,0,0,0,119.6,241l7.23,1.2s8.23-.4,8.43.4-.6,1.41-1.61,1.81a20.16,20.16,0,0,0-4.84,3.38c-1.35,1.36-3.79,3.85-6.4,4.05a63.84,63.84,0,0,1-8.44.2c-1.2-.2-3.61-.8-3.61-.8s-22.49,10.44-25.71,10.64-8.43-5-9-9,4.61-8.43,7-9.23S110.19,243.55,110.19,243.55Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Table--inject-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M167.43,246.77h55.93a0,0,0,0,1,0,0v17a0,0,0,0,1,0,0H170.6a3.16,3.16,0,0,1-3.16-3.16V246.77A0,0,0,0,1,167.43,246.77Z",
    style: {
      fill: "#ccc",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.62,246.77H245a0,0,0,0,1,0,0v13.87a3.16,3.16,0,0,1-3.16,3.16H216.62a0,0,0,0,1,0,0v-17A0,0,0,0,1,216.62,246.77Z",
    style: {
      fill: "#ccc",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.53,248.32H166.67a1.47,1.47,0,0,1-1.48-1.47h0a1.47,1.47,0,0,1,1.48-1.47h56.86a1.47,1.47,0,0,1,1.47,1.47h0A1.47,1.47,0,0,1,223.53,248.32Z",
    style: {
      fill: "#ccc",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.19,248.32H217.1a1.47,1.47,0,0,1-1.47-1.47h0a1.47,1.47,0,0,1,1.47-1.47h28.09a1.47,1.47,0,0,1,1.47,1.47h0A1.47,1.47,0,0,1,245.19,248.32Z",
    style: {
      fill: "#ccc",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.53,254.56H176.18a1.5,1.5,0,0,1-1.5-1.49h0a1.5,1.5,0,0,1,1.5-1.5h32.35a1.5,1.5,0,0,1,1.49,1.5h0A1.49,1.49,0,0,1,208.53,254.56Z",
    style: {
      fill: "#ccc",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170.28,
    y: 263.8,
    width: 2.22,
    height: 21.01,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 201.35,
    y: 263.8,
    width: 2.22,
    height: 21.01,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218.86,
    y: 263.8,
    width: 2.22,
    height: 21.01,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240.48,
    y: 263.8,
    width: 2.22,
    height: 21.01,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.86,
    y: 263.8,
    width: 73.51,
    height: 2.01,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.75,245.38s21-15.38,23.61-16.14,3.5.76,2.59,2.43-22.54,13.56-22.54,13.56Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.43,221.48a5.83,5.83,0,0,0-.73,3c0,3.95,2.76,4.44,3.45,7.52",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.3,215.46a6.11,6.11,0,0,1-1.49,4.12",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.45,227.15c1,2.11,3,3,3,6.34,0,4.51-3.6,4.51-3.6,9",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.48,215.46c0,4.06-2.92,4.46-3.5,7.8",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.1,230.81a6,6,0,0,1,.56,2.68c0,4.51-3.6,4.51-3.6,9",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.66,215.46c0,4.51-3.6,4.51-3.6,9a5.91,5.91,0,0,0,1.14,3.65",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.84,215.46c0,4.51-3.6,4.51-3.6,9s3.6,4.51,3.6,9-3.6,4.51-3.6,9",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.11,234.24a3.09,3.09,0,0,1,.91,2.22c0,3-3.59,3-3.59,6",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174,224.38c0,3-3.59,3-3.59,6a3.15,3.15,0,0,0,.26,1.29",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.82,246.77h55.93a0,0,0,0,1,0,0v17a0,0,0,0,1,0,0H259a3.16,3.16,0,0,1-3.16-3.16V246.77A0,0,0,0,1,255.82,246.77Z",
    style: {
      fill: "#ccc",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305,246.77h28.4a0,0,0,0,1,0,0v13.87a3.16,3.16,0,0,1-3.16,3.16H305a0,0,0,0,1,0,0v-17A0,0,0,0,1,305,246.77Z",
    style: {
      fill: "#ccc",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.92,248.32H255.05a1.47,1.47,0,0,1-1.47-1.47h0a1.47,1.47,0,0,1,1.47-1.47h56.87a1.47,1.47,0,0,1,1.47,1.47h0A1.47,1.47,0,0,1,311.92,248.32Z",
    style: {
      fill: "#ccc",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.57,248.32H305.49a1.47,1.47,0,0,1-1.47-1.47h0a1.47,1.47,0,0,1,1.47-1.47h28.08a1.47,1.47,0,0,1,1.47,1.47h0A1.47,1.47,0,0,1,333.57,248.32Z",
    style: {
      fill: "#ccc",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.91,254.56H264.56a1.49,1.49,0,0,1-1.49-1.49h0a1.5,1.5,0,0,1,1.49-1.5h32.35a1.49,1.49,0,0,1,1.49,1.5h0A1.49,1.49,0,0,1,296.91,254.56Z",
    style: {
      fill: "#ccc",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258.67,
    y: 263.8,
    width: 2.22,
    height: 21.01,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289.73,
    y: 263.8,
    width: 2.22,
    height: 21.01,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 307.25,
    y: 263.8,
    width: 2.22,
    height: 21.01,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.87,
    y: 263.8,
    width: 2.22,
    height: 21.01,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258.25,
    y: 263.8,
    width: 73.51,
    height: 2.01,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.14,245.38s21-15.38,23.6-16.14,3.51.76,2.59,2.43-22.53,13.56-22.53,13.56Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.68,236.5a5.9,5.9,0,0,0,.73-3c0-4.51-3.6-4.51-3.6-9s3.6-4.51,3.6-9",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.81,242.51a6.06,6.06,0,0,1,1.5-4.12",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.63,242.51c0-4.51,3.6-4.51,3.6-9s-3.6-4.51-3.6-9,3.6-4.51,3.6-9",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291,227.16a6,6,0,0,1-.56-2.68c0-4.51,3.6-4.51,3.6-9",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.45,242.51c0-4.51,3.6-4.51,3.6-9a5.91,5.91,0,0,0-1.14-3.65",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.27,242.51c0-4.51,3.6-4.51,3.6-9s-3.6-4.51-3.6-9,3.6-4.51,3.6-9",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323,223.73a3.09,3.09,0,0,1-.91-2.22c0-3,3.6-3,3.6-6",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.09,233.6c0-3,3.6-3,3.6-6a3,3,0,0,0-.27-1.29",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321,280.49H309.84a2.13,2.13,0,0,1-2.12-2.13h0a2.13,2.13,0,0,1,2.12-2.13H321a2.13,2.13,0,0,1,2.12,2.13h0A2.13,2.13,0,0,1,321,280.49Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.24,280.49H325.08a2.13,2.13,0,0,1-2.13-2.13h0a2.13,2.13,0,0,1,2.13-2.13h11.16a2.13,2.13,0,0,1,2.12,2.13h0A2.13,2.13,0,0,1,336.24,280.49Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.38,276.24H317.22a2.12,2.12,0,0,1-2.12-2.12h0a2.13,2.13,0,0,1,2.12-2.13h11.16a2.13,2.13,0,0,1,2.13,2.13h0A2.12,2.12,0,0,1,328.38,276.24Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.73,280.49H341.57a2.14,2.14,0,0,1-2.13-2.13h0a2.14,2.14,0,0,1,2.13-2.13h11.16a2.13,2.13,0,0,1,2.12,2.13h0A2.13,2.13,0,0,1,352.73,280.49Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368,280.49H356.8a2.13,2.13,0,0,1-2.12-2.13h0a2.13,2.13,0,0,1,2.12-2.13H368a2.13,2.13,0,0,1,2.13,2.13h0A2.13,2.13,0,0,1,368,280.49Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.11,276.24H349a2.12,2.12,0,0,1-2.12-2.12h0A2.13,2.13,0,0,1,349,272h11.16a2.13,2.13,0,0,1,2.12,2.13h0A2.12,2.12,0,0,1,360.11,276.24Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.09,276.24H332.93a2.12,2.12,0,0,1-2.12-2.12h0a2.13,2.13,0,0,1,2.12-2.13h11.16a2.13,2.13,0,0,1,2.12,2.13h0A2.12,2.12,0,0,1,344.09,276.24Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.24,272.16H325.08A2.12,2.12,0,0,1,323,270h0a2.13,2.13,0,0,1,2.13-2.13h11.16a2.12,2.12,0,0,1,2.12,2.13h0A2.12,2.12,0,0,1,336.24,272.16Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.94,272.16H340.78a2.12,2.12,0,0,1-2.12-2.12h0a2.12,2.12,0,0,1,2.12-2.13h11.16a2.13,2.13,0,0,1,2.13,2.13h0A2.12,2.12,0,0,1,351.94,272.16Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 307.36,
    y: 279.66,
    width: 63.86,
    height: 4.92,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.63,281.21H306.28a1.47,1.47,0,0,1-1.48-1.47h0a1.47,1.47,0,0,1,1.48-1.47h65.35a1.47,1.47,0,0,1,1.47,1.47h0A1.47,1.47,0,0,1,371.63,281.21Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 362.81,
    cy: 237.6,
    r: 2.37,
    style: {
      fill: "#1D50FF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.93,235.88a2.38,2.38,0,1,1-2.37-2.37A2.37,2.37,0,0,1,369.93,235.88Z",
    style: {
      fill: "#1D50FF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 371.22,
    cy: 236.74,
    r: 2.37,
    style: {
      fill: "#1D50FF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 375.75,
    cy: 236.09,
    r: 2.37,
    style: {
      fill: "#1D50FF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 386.53,
    cy: 234.58,
    r: 2.37,
    style: {
      fill: "#1D50FF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 398.82,
    cy: 237.17,
    r: 2.37,
    style: {
      fill: "#1D50FF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 382.22,
    cy: 237.17,
    r: 2.37,
    style: {
      fill: "#1D50FF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.78,236.74a2.37,2.37,0,1,1-2.37-2.37A2.37,2.37,0,0,1,392.78,236.74Z",
    style: {
      fill: "#1D50FF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.93,237.17a2.37,2.37,0,1,1-2.37-2.37A2.37,2.37,0,0,1,405.93,237.17Z",
    style: {
      fill: "#1D50FF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 396.23,
    cy: 236.74,
    r: 2.37,
    style: {
      fill: "#1D50FF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.56,239.54a2.37,2.37,0,1,1-2.37-2.37A2.37,2.37,0,0,1,403.56,239.54Z",
    style: {
      fill: "#1D50FF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.93,238.25a2.38,2.38,0,1,1-2.37-2.37A2.37,2.37,0,0,1,369.93,238.25Z",
    style: {
      fill: "#1D50FF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.1,239.11a2.37,2.37,0,1,1-2.37-2.37A2.37,2.37,0,0,1,375.1,239.11Z",
    style: {
      fill: "#1D50FF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 378.12,
    cy: 238.47,
    r: 2.37,
    style: {
      fill: "#1D50FF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.17,238a2.37,2.37,0,1,1-2.37-2.37A2.38,2.38,0,0,1,387.17,238Z",
    style: {
      fill: "#1D50FF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.41,238.25a2.38,2.38,0,1,1-2.37-2.37A2.37,2.37,0,0,1,390.41,238.25Z",
    style: {
      fill: "#1D50FF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.23,239.11a2.37,2.37,0,1,1-2.37-2.37A2.37,2.37,0,0,1,396.23,239.11Z",
    style: {
      fill: "#1D50FF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.86,239.11s14.46-17.38,16-18.31,4.66,0,3.42,2.49-14.48,16.25-14.48,16.25Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.32,239h50.9a1.66,1.66,0,0,1,1.54,2.26l-6.67,17a1.66,1.66,0,0,1-1.54,1.05H364a1.66,1.66,0,0,1-1.54-1.05l-6.66-17A1.65,1.65,0,0,1,357.32,239Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 361.74,
    y: 259.38,
    width: 41.61,
    height: 3.66,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 361.74,
    y: 280.93,
    width: 41.61,
    height: 3.66,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 362.59,
    y: 261.96,
    width: 2.83,
    height: 22.64,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 374.23,
    y: 261.96,
    width: 2.83,
    height: 22.64,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 392.77,
    y: 261.96,
    width: 2.83,
    height: 22.64,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 399.68,
    y: 261.96,
    width: 2.8,
    height: 22.64,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.65,271.7s-2.5-2.29-1.37-3,2.28,2.3,3,.46,1.36-3.21,2.27-2.29,0,1.14.91.91,1.36-2.29,2.27-1.14-.23.91.91,1.14-.91.69,1.13.23l2-.46h0c2.5.23,3.18.46,3,1.38l-.22.92s2.49,1.15,2.95.46-.68-2.07,1.59-2.07.91-.46,2.27,0,.68-.91,2.05-1.37-.23-2.07,1.36-.46.23,2.52,1.59,1.6,2-1.6,2.73,0,.22,2.76,1.81,1.61-.45-2.07,1.59-1.15l2.05.92s.91,1.15,1.82,1.15.9,0,2.49-.69,1.82-2.75,3.87-1.61-.46,1.84,2,1.15l2.5-.69,2,.92,3-1.38s3.12,3.09,0,3.73S395.65,271.7,395.65,271.7Z",
    style: {
      fill: "#1D50FF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 393.1,
    y: 271.99,
    width: 55.93,
    height: 12.59,
    style: {
      fill: "#ccc",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 448.93,
    y: 271.99,
    width: 25.49,
    height: 12.59,
    style: {
      fill: "#ccc",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.19,273.54H392.33a1.47,1.47,0,0,1-1.47-1.47h0a1.47,1.47,0,0,1,1.47-1.47h56.86a1.47,1.47,0,0,1,1.48,1.47h0A1.47,1.47,0,0,1,449.19,273.54Z",
    style: {
      fill: "#ccc",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475,273.54h-30.6a1.47,1.47,0,0,1-1.47-1.47h0a1.47,1.47,0,0,1,1.47-1.47H475a1.47,1.47,0,0,1,1.47,1.47h0A1.47,1.47,0,0,1,475,273.54Z",
    style: {
      fill: "#ccc",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.23,279.78H404.88a1.5,1.5,0,0,1-1.49-1.5h0a1.49,1.49,0,0,1,1.49-1.49h32.35a1.5,1.5,0,0,1,1.5,1.49h0A1.5,1.5,0,0,1,437.23,279.78Z",
    style: {
      fill: "#ccc",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.3,279a4.92,4.92,0,1,1-4.91-4.91A4.91,4.91,0,0,1,494.3,279Z",
    style: {
      fill: "#1D50FF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 500.09,
    cy: 278.95,
    r: 4.91,
    style: {
      fill: "#1D50FF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.7,279a4.91,4.91,0,1,1-4.91-4.91A4.91,4.91,0,0,1,515.7,279Z",
    style: {
      fill: "#1D50FF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.4,279a4.91,4.91,0,1,1-4.91-4.91A4.91,4.91,0,0,1,526.4,279Z",
    style: {
      fill: "#1D50FF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.1,279a4.91,4.91,0,1,1-4.91-4.91A4.91,4.91,0,0,1,537.1,279Z",
    style: {
      fill: "#1D50FF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 483.04,
    y: 279.66,
    width: 55.93,
    height: 4.92,
    style: {
      fill: "#ccc",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.14,281.21H482.27a1.47,1.47,0,0,1-1.47-1.47h0a1.47,1.47,0,0,1,1.47-1.47h56.87a1.47,1.47,0,0,1,1.47,1.47h0A1.47,1.47,0,0,1,539.14,281.21Z",
    style: {
      fill: "#ccc",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.28,284.84H549.64a6.76,6.76,0,0,1,6.76,6.76V433.16a0,0,0,0,1,0,0H143.53a0,0,0,0,1,0,0V291.6A6.76,6.76,0,0,1,150.28,284.84Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.17,286.1a.83.83,0,0,1,1.42-.47c4,4.18,19.32,18.23,47.14,18.6,26.42.36,43.07-12.93,47.73-17.19a.84.84,0,0,1,1.4.7c0,5.89-1.28,23.29-15.33,33.31-17.1,12.19-52.84,14.72-73-4.62C152.66,305.1,154.23,290.86,155.17,286.1Z",
    style: {
      fill: "#1D50FF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170,301.92a36.89,36.89,0,0,0,5.33,2.73",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.59,285.63a30.28,30.28,0,0,0,9.24,13.21",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.45,318.25a69.11,69.11,0,0,1-7.81-1",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.86,287.74s-6.79,14-23.49,24.06c-9.53,5.76-21.45,6.86-30.3,6.67",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.57,310.54S215,315.17,238.3,300",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.68,286.1a.83.83,0,0,1,1.42-.47c4,4.18,19.32,18.23,47.14,18.6,26.42.36,43.07-12.93,47.73-17.19a.84.84,0,0,1,1.4.7c0,5.89-1.29,23.29-15.33,33.31-17.1,12.19-52.84,14.72-73-4.62C250.17,305.1,251.74,290.86,252.68,286.1Z",
    style: {
      fill: "#1D50FF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.55,301.92a36.89,36.89,0,0,0,5.33,2.73",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.1,285.63a30.28,30.28,0,0,0,9.24,13.21",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292,318.25a69.83,69.83,0,0,1-7.82-1",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.37,287.74s-6.79,14-23.49,24.06c-9.53,5.76-21.45,6.86-30.3,6.67",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.08,310.54s19.42,4.63,42.73-10.51",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.19,286.1a.83.83,0,0,1,1.42-.47c4,4.18,19.31,18.23,47.14,18.6,26.42.36,43.07-12.93,47.73-17.19a.84.84,0,0,1,1.39.7c0,5.89-1.28,23.29-15.33,33.31-17.09,12.19-52.83,14.72-73-4.62C347.68,305.1,349.24,290.86,350.19,286.1Z",
    style: {
      fill: "#1D50FF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.06,301.92a35.88,35.88,0,0,0,5.33,2.73",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.61,285.63a30.28,30.28,0,0,0,9.24,13.21",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.47,318.25a69.83,69.83,0,0,1-7.82-1",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.87,287.74s-6.78,14-23.49,24.06c-9.52,5.76-21.44,6.86-30.3,6.67",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.59,310.54S410,315.17,433.32,300",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.7,286.1a.83.83,0,0,1,1.42-.47c3.95,4.18,19.31,18.23,47.13,18.6,26.43.36,43.08-12.93,47.74-17.19a.84.84,0,0,1,1.39.7c0,5.89-1.28,23.29-15.33,33.31-17.09,12.19-52.83,14.72-73-4.62C445.19,305.1,446.75,290.86,447.7,286.1Z",
    style: {
      fill: "#1D50FF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.57,301.92a36.25,36.25,0,0,0,5.32,2.73",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.12,285.63a30.28,30.28,0,0,0,9.24,13.21",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487,318.25a69.48,69.48,0,0,1-7.81-1",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.38,287.74s-6.78,14-23.49,24.06c-9.52,5.76-21.45,6.86-30.3,6.67",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.09,310.54s19.43,4.63,42.74-10.51",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 164.54,
    y1: 433.05,
    x2: 164.54,
    y2: 346.58,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 181.61,
    y1: 373.63,
    x2: 181.61,
    y2: 394.47,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 181.61,
    y1: 335.05,
    x2: 181.61,
    y2: 365.65,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 203.43,
    y1: 419.31,
    x2: 203.43,
    y2: 362.1,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 203.43,
    y1: 432.17,
    x2: 203.43,
    y2: 424.18,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 257.97,
    y1: 364.32,
    x2: 257.97,
    y2: 397.58,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 239,
    y1: 409.11,
    x2: 239,
    y2: 417.09,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 239,
    y1: 351.46,
    x2: 239,
    y2: 403.79,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 300.18,
    y1: 342.15,
    x2: 300.18,
    y2: 376.29,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 291.17,
    y1: 415.76,
    x2: 291.17,
    y2: 382.94,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 345.23,
    y1: 423.3,
    x2: 345.23,
    y2: 373.63,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 334.33,
    y1: 383.39,
    x2: 334.33,
    y2: 431.72,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 334.33,
    y1: 339.49,
    x2: 334.33,
    y2: 376.74,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 358.99,
    y1: 433.05,
    x2: 358.99,
    y2: 346.58,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 376.06,
    y1: 373.63,
    x2: 376.06,
    y2: 394.47,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 376.06,
    y1: 335.05,
    x2: 376.06,
    y2: 365.65,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 397.88,
    y1: 419.31,
    x2: 397.88,
    y2: 362.1,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 397.88,
    y1: 432.17,
    x2: 397.88,
    y2: 424.18,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 452.42,
    y1: 364.32,
    x2: 452.42,
    y2: 397.58,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 433.45,
    y1: 409.11,
    x2: 433.45,
    y2: 417.09,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 433.45,
    y1: 351.46,
    x2: 433.45,
    y2: 403.79,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 494.63,
    y1: 342.15,
    x2: 494.63,
    y2: 376.29,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 485.62,
    y1: 415.76,
    x2: 485.62,
    y2: 382.94,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 539.68,
    y1: 423.3,
    x2: 539.68,
    y2: 373.63,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 528.77,
    y1: 383.39,
    x2: 528.77,
    y2: 431.72,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 528.77,
    y1: 339.49,
    x2: 528.77,
    y2: 376.74,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-3--inject-8"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "539.28 249.64 513.06 249.64 507.82 247.26 540.03 247.26 539.28 249.64",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.8,247.73s-2.92-1.87-5-3.53a22.62,22.62,0,0,0-5.21-2.74,2.17,2.17,0,0,0-1.92.15c-1.6.93-4.88,2.75-6.28,2.75-1.87,0-2.91,1.67-.42,2.5s5.3-.79,5.3-.79-3.75,4-5,4.16-11.48-.58-11.27.46,11.06,2.87,13.56,3.29,5.62.62,6.87,0,3.54-1.46,3.54-1.46l4,.63Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564.3,148s-5.8,10.2-6.23,12.6a24.23,24.23,0,0,0,.14,6c0,.57-4.24,4.25-4.39,5.24s2.84,2.55,2.84,2.55,2.54,9.2,3,10.48,2,1.55,2.69,1.55a56.67,56.67,0,0,0,5.52-1.55l2.83,6.79L587.38,182l-2-6.08s7.64-9.49,7.22-14.3a17.1,17.1,0,0,0-12-14.45C572.51,144.75,566.71,146.3,564.3,148Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.62,161.6a17.1,17.1,0,0,0-12-14.45c-8.07-2.4-13.87-.85-16.28.85,0,0-1.31,2.31-2.73,5l.47,0s9.91-1.56,10.76-.14-1.7,6.37-1.7,6.37,4.1.85,4,2.12-2.12,3.83-.85,4.53,2.27.29,2.55-.7,4.11-2.41,5.38,1.84-5.24,7.08-5.24,7.08a12.06,12.06,0,0,0,8.63,1.66C586.54,174.44,593,166,592.62,161.6Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.89,166.34c0,1-.32,1.77-.71,1.77s-.71-.79-.71-1.77.32-1.77.71-1.77S562.89,165.36,562.89,166.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.77,162.45s2.41-3,5-.15",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.2,175.47s2.27.43,4.68-2",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.72,197.27s-4.39,3.83-5.1,6.66-2.27,13-1.56,15.15,7.51-5.81,7.51-5.81l-4.25-8.92s4.11-4.1,4.25-4.67S565.72,197.27,565.72,197.27Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587.38,180s-21.8,13.88-22,14.58.71,8.22.71,8.22L589.93,184Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.77,417.33s2,13.51.79,14.5-9.13,2-11.92,1.79-15.29.79-17.07.79.2-3,1.39-3.57,6.95-4.37,8.34-6.36l4.17-6Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.12,291l-.4,37.33s.79,27.81,2.18,35.55-.52,43.89.67,47.66a28.25,28.25,0,0,1,1,8.34l-8.14.8a28.16,28.16,0,0,1-4.37,0s3.9-46.07,1.52-63.75,2.18-40.71,2.18-50.84S599.12,291,599.12,291Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.16,416.14s-2,5.56-3.57,6.95-9.34,6-12.91,7-1,3,0,3.58,13.7,1.19,23.23.59,13.31-.4,14.1-1.59-1-15.49-1-15.49Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.16,282.69s3.57,34,3.57,52,3.6,48.92,4.39,52.69,2,24.76,2,24.76-2.79,2.78-2.59,4.17a18.51,18.51,0,0,1,.2,2.38s1.19,1.39,8.74,1.79,12.91.2,12.91.2,4.3-31.18,1.92-48.06-1.59-21.45-1.79-30.38,3-35.15,3-35.15,4.37-12.52,4.76-16.49a82.86,82.86,0,0,0,.2-9.33Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.5,182.69s-22.23,17.27-23.5,19-7.5,17-7.79,22.23.29,30.16.43,30.87.56,41.2.56,41.2a171.61,171.61,0,0,0,27.06,2.25c13.3-.14,20.79-5.47,20.79-5.47s-2.54-28.21-3.39-32.6a78,78,0,0,1-1-10.62s2.55-23.22.71-35.82-5.24-20-7.22-22.51S592.33,184.25,589.5,182.69Z",
    style: {
      fill: "#1D50FF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "561.08 268.58 575.28 269.22 574.64 272.13 565.92 271.48",
    style: {
      fill: "#1D50FF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "566.08 212.89 574.64 202.09 573.67 197.89 579.15 197.57 592.07 188.21",
    style: {
      fill: "#1D50FF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 561.08,
    y1: 219.19,
    x2: 564.27,
    y2: 215.17,
    style: {
      fill: "#1D50FF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.62,205.06s-3.26,6.51-2.83,10.05,3.68,30.44,3.68,30.44l-29.75.47-1,12.18s20.12,3.78,32.58,3.35,14.87-.85,15.29-1.7,2-30.86,1.42-36.1a34.83,34.83,0,0,0-2.13-9.63",
    style: {
      fill: "#1D50FF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M459,171s-1.86,4.83-1.49,6.19,1.36,4.82.25,6.18-2.47,2.1-1.85,3.34,3.21,2.1,3.21,2.1,2.23,8.41,3.59,8.91,3-1.12,5.07-1.24,1.73-9.15,2.47-15.34S468,172,464.42,170.86,459,171,459,171Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.34,189.16a2.75,2.75,0,0,0,2.22-1.6",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.83,180.51c.08.85-.1,1.57-.41,1.6s-.62-.64-.7-1.49.1-1.56.41-1.59S460.75,179.66,460.83,180.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.61,177.41a1.8,1.8,0,0,1,2.59-.49",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.86,332.35s-.19,14.6,1.37,20.25,6.23,12.26,7.59,29.2,1.75,28.82,2.92,31.94,2.73,7,3.12,10.12a94.08,94.08,0,0,1,.19,9.93h-4.28l-1-5.45L502.62,434s-10.7.19-11.87,0,.39-1.95,1.94-3.51,4.29-9.34,5.07-11.29-.28-4.91-.59-6.23c-1.55-6.62-6-18.69-8-24.93a97.82,97.82,0,0,1-3.12-14.21c-.39-2.34-5.25-24.14-5.84-26.09s-1.56-17.14-1.56-17.14Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.24,328.86s.78,18.69,2.53,27.65,8,46.34,8,54.32-6.23,15.77-6.23,15.77-3.31,2.73-5.64,3.31-2.92,2.73-1.37,3.31,15.78,1.37,17.14.39,3.7-6.23,4.09-6.81.19,7,.19,7h3.7s.78-5.65,1.17-9.74-.78-7.59-1.75-11.29a41.08,41.08,0,0,1-1.17-7.4s.19-15.77,1-20.84,3.9-16.74,1-26.48-3.31-11.49-3.31-12.65V330.8Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.75,229.3s-2.88-3.09-4.12-3.66-5.76-.16-7.32-1.27-1.59.73-.3,2a8.89,8.89,0,0,0,3.93,1.76s-5.48-.32-7.13.63-3.19,2.39-.8,2.11l2.4-.28,1.73.46a18.49,18.49,0,0,0-3.64,1.29c-.74.55-1.58,1.44-1.48,1.91s1.08.66,1.44.46,2-1,2-1l2.58-.2s-2.51,1-2.79,1.26-1.35,1.42-1.19,1.69,1.25,0,1.69-.22a13.68,13.68,0,0,1,1.35-.6l1.59-.09a8,8,0,0,0-2.17,1.42c-.29.52,0,.82.56.67s2.35-.71,2.35-.71l1.85-.24,2.78.15a6.25,6.25,0,0,0,2.73.36,13.76,13.76,0,0,0,2.67-.54,17.48,17.48,0,0,1,2.64.71l1.57-6.12Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.94,228.13a15.67,15.67,0,0,1,1,2.69c.28,1.19,3.65,1.65,4.55,1.89",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 417.47,
    y1: 230.29,
    x2: 419.34,
    y2: 235.77,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "433.63 231.29 431.32 241.01 458.6 255.92 461.82 242.44 433.63 231.29",
    style: {
      fill: "#1D50FF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.22,207.92s-13.83,15.45-13.51,22.29,5.37,22.13,5.37,22.13-4.56,53.37-4.56,54.35-2.44,26.52-2.44,26.52,7.16.82,16.76,1.79,20.67,2,25.71.17,11.56-3.58,12.05-3.91-2.61-24.41-3.75-34-1-13.5-3.09-27.17A146.58,146.58,0,0,0,495.39,247s2.44-26.85,2.44-32.06-9.43-7-16.43-8.95S468.22,207.92,468.22,207.92Z",
    style: {
      fill: "#b2b2b2",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.08,206s-3.58,17.25-4.88,27.83-1.47,52.56-1.47,52.56,15.14,5,23.6,3.74,17.25-4.07,19.69-6c0,0-1.63-13.67-3.1-21.48s-4.06-17.25-4.06-17.9,1.95-26.2,1.79-30.92-3.58-6-12.86-9.27S469.68,203,467.08,206Z",
    style: {
      fill: "#1D50FF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.43,159.11s-7.67,4.08-8.66,7.54,9.65,6.68,10.89,7.67.49,8.41.37,13.36-1.24,19.54,1,23,9.27,8.91,19.66,8.54,13.48-2.6,14.1-8.78.5-9.16-1.48-13S497,194.23,494,188.3s-2.23-16.45-5.81-22.64S473.57,152.43,463.43,159.11Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "435.73 248.87 409.51 248.87 404.27 246.48 440.98 246.48 435.73 248.87",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.25,247s-2.28-1.46-3.91-2.77a17.72,17.72,0,0,0-4.07-2.13,1.68,1.68,0,0,0-1.5.11c-1.25.73-3.82,2.15-4.91,2.15-1.46,0-2.28,1.31-.32,2a5.78,5.78,0,0,0,4.13-.62s-2.93,3.09-3.9,3.25-4.88.82-4.72,1.63,4.55,1,6.51,1.3,4.39.49,5.37,0,2.76-1.14,2.76-1.14l3.1.49Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.82,221.42l-2.44,28.8a14.31,14.31,0,0,0-3.42-.65c-.65.17-1,1.14-1,1.14l-18.88-4.88-1.3,7.65s31.4,12.69,33.52,13,3.91-.17,4.07-1.31,4.88-41.82,4.88-41.82",
    style: {
      fill: "#1D50FF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-8"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 25.06,
    y1: 433.16,
    x2: 720.07,
    y2: 433.16,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTable);
export default __webpack_public_path__ + "static/media/table.92a18f8b4a42eb8180343c2b4936b1c3.svg";
export { ForwardRef as ReactComponent };